/* eslint-disable */
import { notification } from 'antd'
import { gql } from 'apollo-boost'
import moment from 'moment'
import apolloClient from '../apollo/config'

export async function getCourseUsers(payload) {
  return apolloClient
    .query({
      query: gql`
        query getCourseUsers($name: String, $email: String) {
          getCourseUsers(email_Icontains: $email, name_Icontains: $name) {
            edges {
              node {
                id
                name
                email
                phoneNo
                purchasedcoursetemplatesSet {
                  edges {
                    node {
                      id
                      courseTemplate {
                        id
                        name
                      }
                    }
                  }
                }
                user {
                  id
                  firstName
                  username
                  email
                }
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
      fetchPolicy: 'network-only',
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('get public Templates ERORR ', JSON.stringify(error))
    })
}

export async function createCourseUser(payload) {
  return apolloClient
    .mutate({
      mutation: gql`
        mutation createCourseUser($name: String!, $email: String!, $phoneNo: String) {
          createCourseUser(input: { name: $name, email: $email, phoneNo: $phoneNo }) {
            status
            message
            courseUserDetails {
              id
              name
              email
              phoneNo
              purchasedcoursetemplatesSet {
                edges {
                  node {
                    id
                    courseTemplate {
                      id
                      name
                    }
                  }
                }
              }
              user {
                id
                firstName
                username
                email
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('create Course user ERORR ', JSON.stringify(error))
    })
}

export async function updateCourseUser(payload) {
  return apolloClient
    .mutate({
      mutation: gql`
        mutation updateCourseUser(
          $courseUserId: ID!
          $name: String!
          $email: String!
          $phoneNo: String
        ) {
          updateCourseUser(
            input: { courseUserId: $courseUserId, name: $name, email: $email, phoneNo: $phoneNo }
          ) {
            status
            message
            courseUserDetails {
              id
              name
              email
              phoneNo
              purchasedcoursetemplatesSet {
                edges {
                  node {
                    id
                    courseTemplate {
                      id
                      name
                    }
                  }
                }
              }
              user {
                id
                firstName
                username
                email
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('edit Course user ERORR ', JSON.stringify(error))
    })
}

export async function getCourseTemplates() {
  return apolloClient
    .query({
      query: gql`
        query {
          getPublicCourses {
            id
            name
            isActive
            coursetemplatemodulesSet {
              edges {
                node {
                  id
                  name
                  description
                }
              }
            }
          }
        }
      `,
      fetchPolicy: 'network-only',
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('get Templates ERORR ', JSON.stringify(error))
    })
}

export async function assignCourseToUser(payload) {
  return apolloClient
    .mutate({
      mutation: gql`
        mutation assignCourseToUser(
          $courseUser: ID!
          $courseTemplateId: ID!
          $entireCourse: Boolean
          $assignModules: [ID]
        ) {
          assignCourseToUser(
            input: {
              courseUser: $courseUser
              courseTemplate: $courseTemplateId
              assignModules: $assignModules
              entireCourse: $entireCourse
            }
          ) {
            status
            message
            purchasedCourses {
              id
              isActive
              courseTemplate {
                id
                name
                isActive
                coursetemplatemodulesSet {
                  edges {
                    node {
                      id
                      name
                      description
                    }
                  }
                }
              }
              courseUser {
                id
                email
                name
              }
              assignedModules {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('edit Course user ERORR ', JSON.stringify(error))
    })
}

export async function updateAssignedCourse(payload) {
  return apolloClient
    .mutate({
      mutation: gql`
        mutation updateAssignedCourse(
          $purchasedCourse: ID!
          $assignModules: [ID]
          $entireCourse: Boolean
          $removeModules: [ID]
        ) {
          updateAssignedCourse(
            input: {
              purchasedCourse: $purchasedCourse
              assignModules: $assignModules
              removeModules: $removeModules
              entireCourse: $entireCourse
            }
          ) {
            status
            message
            purchasedCourses {
              id
              isActive
              courseTemplate {
                id
                name
                isActive
                coursetemplatemodulesSet {
                  edges {
                    node {
                      id
                      name
                      description
                    }
                  }
                }
              }
              courseUser {
                id
                email
                name
              }
              assignedModules {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('edit Course user ERORR ', JSON.stringify(error))
    })
}
export async function activeInactiveUserCourse(payload) {
  return apolloClient
    .mutate({
      mutation: gql`
        mutation activeInactiveUserCourse($id: ID!, $isActive: Boolean!) {
          activeInactiveUserCourse(input: { id: $id, isActive: $isActive }) {
            message
            status
          }
        }
      `,
      variables: {
        ...payload,
      },
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('active Course user ERORR ', JSON.stringify(error))
    })
}
export async function getPurchasedCourseByCourseUser(payload) {
  return apolloClient
    .query({
      query: gql`
        query getPurchasedCourseByCourseUser($courseUserId: ID!) {
          getPurchasedCourseByCourseUser(courseUserId: $courseUserId) {
            edges {
              node {
                id
                isActive
                courseUser {
                  id
                  email
                  name
                  phoneNo
                  user {
                    id
                  }
                }
                assignedModules {
                  edges {
                    node {
                      id
                      name
                      daysForCompletion
                      usercoursemodulevalidationSet {
                        edges {
                          node {
                            id
                            expireTime
                          }
                        }
                      }
                    }
                  }
                }
                courseTemplate {
                  id
                  name
                  isActive
                  coursetemplatemodulesSet {
                    edges {
                      node {
                        id
                        name
                        description
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
      fetchPolicy: 'network-only',
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('get public Templates ERORR ', JSON.stringify(error))
    })
}

export async function changeModuleAvailability(payload) {
  return apolloClient
    .mutate({
      mutation: gql`
        mutation updateUserCourseValidationBySuperadmin(
          $userCourse: ID!
          $moduleId: ID!
          $expireTime: DateTime
        ) {
          updateUserCourseValidationBySuperadmin(
            input: { userCourse: $userCourse, moduleId: $moduleId, expireTime: $expireTime }
          ) {
            message
            status
            userCourseModuleValidation {
              id
              expireTime
              module {
                id
                name
              }
              status
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
    })
    .then(result => {
      return result.data
    })
    .catch(error => {
      console.log('edit Course user ERORR ', JSON.stringify(error))
    })
}

export async function getUserCourseModuleValidations(payload) {
  return apolloClient
    .query({
      query: gql`
        query getUserCourseModuleValidations($userCourse: ID!) {
          getUserCourseModuleValidations(userCourseId: $userCourse) {
            edges {
              node {
                id
                userCourse {
                  id
                }
                module {
                  id
                  name
                }
                expireTime
              }
            }
          }
        }
      `,
      variables: {
        ...payload,
      },
      fetchPolicy: 'network-only',
    })
    .then(result => {
      console.log('THE RESULT', result)
      return result.data
    })
    .catch(error => {
      console.log('get public Templates ERORR ', JSON.stringify(error))
    })
}

export async function getUserModuleResults(payload) {
  return apolloClient
    .query({
      query: gql`
        query getUserModuleResults($userId: ID!) {
          getPurchasedCourseByCourseUser(courseUserId: $userId) {
            edges {
              node {
                id
                courseTemplate {
                  id
                  name
                }
                assignedModules {
                  edges {
                    node {
                      id
                      name
                      coursemodulestestsSet {
                        edges {
                          node {
                            id
                            title
                          }
                        }
                      }
                    }
                  }
                }
                userscoursemodulesprogressSet {
                  edges {
                    node {
                      id
                      status
                      score
                      createdAt
                      updatedAt
                      test {
                        id
                      }
                      module {
                        id
                      }
                      courseTemplate {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        userId: payload.userId,
      },
      fetchPolicy: 'network-only',
    })
    .then(result => result)
    .catch(error => {
      error.graphQLErrors.map(item => {
        return notification.error({
          message: 'Error',
          description: item.message,
        })
      })
    })
}

export async function getUserCoursesList(payload) {
  return apolloClient
    .query({
      query: gql`
        query getUserCoursesList($userId: ID!) {
          getPurchasedCourseByCourseUser(courseUserId: $userId) {
            edges {
              node {
                id
                courseTemplate {
                  id
                  name
                }
              }
            }
          }
        }
      `,
      variables: {
        userId: payload.userId,
      },
      fetchPolicy: 'network-only',
    })
    .then(result => result)
    .catch(error => {
      error.graphQLErrors.map(item => {
        return notification.error({
          message: 'Error',
          description: item.message,
        })
      })
    })
}

export async function getCourseModuleResults(payload) {
  return apolloClient
    .query({
      query: gql`
        query getCourseModuleResults($userId: ID!, $courseId: ID!) {
          getPurchasedCourseByCourseUser(courseUserId: $userId, courseTemplate: $courseId) {
            edges {
              node {
                id
                assignedModules {
                  edges {
                    node {
                      id
                      name
                      coursemodulestestsSet {
                        edges {
                          node {
                            id
                            title
                          }
                        }
                      }
                    }
                  }
                }
                userscoursemodulesprogressSet {
                  edges {
                    node {
                      id
                      status
                      score
                      createdAt
                      updatedAt
                      test {
                        id
                      }
                      module {
                        id
                      }
                      courseTemplate {
                        id
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `,
      variables: {
        userId: payload.userId,
        courseId: payload.courseId,
      },
      fetchPolicy: 'network-only',
    })
    .then(result => result)
    .catch(error => {
      error.graphQLErrors.map(item => {
        return notification.error({
          message: 'Error',
          description: item.message,
        })
      })
    })
}

// Modify the transform function to handle both course list and detailed data
export function transformCourseList(data) {
  const purchasedCourses = data.getPurchasedCourseByCourseUser?.edges || []
  return purchasedCourses.map(({ node }) => ({
    id: node.courseTemplate.id,
    name: node.courseTemplate.name,
  }))
}

export function transformCourseDetails(data) {
  const purchasedCourse = data.getPurchasedCourseByCourseUser?.edges?.[0]?.node
  if (!purchasedCourse) return null

  const modules = {}

  // Process modules
  purchasedCourse.assignedModules.edges.forEach(({ node: module }) => {
    const moduleId = module.id

    if (!modules[moduleId]) {
      modules[moduleId] = {
        id: moduleId,
        name: module.name,
        tests: {},
      }
    }

    // Process tests
    module.coursemodulestestsSet.edges.forEach(({ node: test }) => {
      const testId = test.id

      if (!modules[moduleId].tests[testId]) {
        modules[moduleId].tests[testId] = {
          id: testId,
          title: test.title,
          attempts: [],
        }
      }
    })
  })

  // Process progress/attempts
  purchasedCourse.userscoursemodulesprogressSet.edges.forEach(({ node: progress }) => {
    if (progress.test) {
      const moduleId = progress.module.id
      const testId = progress.test.id

      if (modules[moduleId]?.tests[testId]) {
        modules[moduleId].tests[testId].attempts.push({
          date: progress.createdAt,
          score: progress.score,
          status: progress.status.toLowerCase(),
        })
      }
    }
  })

  // Convert objects to arrays and sort attempts
  return {
    modules: Object.values(modules).map(module => ({
      ...module,
      tests: Object.values(module.tests).map(test => ({
        ...test,
        attempts: test.attempts.sort((a, b) => new Date(b.date) - new Date(a.date)),
      })),
    })),
  }
}
